var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDossierBotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 39,
    viewBox: "0 0 28 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51006 3.96068C9.5716 5.20409 10.0108 7.41235 11.4514 9.10653C12.5955 10.4538 15.2866 10.8108 16.758 10.9906C19.3875 11.3123 21.3177 12.8038 21.3177 15.045C21.3177 16.962 19.9833 18.5651 17.614 19.0386C15.3873 19.4843 13.5243 19.8414 12.1312 20.981C10.8808 22.0066 10.0667 23.5134 9.53244 26.2838C9.08486 28.6111 7.42604 30.0343 5.06508 30.0343C2.70412 30.0343 0.580931 28.2161 0.580931 25.9749C0.580931 23.7337 2.32647 22.1687 4.78534 21.9281C7.87361 21.5938 12.2878 19.1576 12.2878 15.3109C12.2878 11.4642 8.97856 8.9014 4.66785 8.10116C2.08031 7.64786 0.547363 6.1892 0.547363 4.05945C0.547363 1.81827 2.55586 0 5.03151 0C7.50716 0 9.45131 1.76509 9.51006 3.96068Z",
    fill: "url(#paint0_linear_117_216)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2129 38.1348C24.8363 38.9204 24.3311 39.7093 23.6514 40.4258C22.2638 41.8878 20.4384 42.7817 18.21 43.0918C17.2263 43.229 16.3517 42.4446 16.3516 41.4443V41.4414C16.3518 40.6129 16.9582 39.9138 17.7725 39.7979C19.0362 39.6171 20.0773 39.1789 20.8867 38.4922C21.2108 38.6227 21.5454 38.7395 21.8906 38.8398C22.8102 38.7928 23.7552 38.6215 24.7051 38.3145C24.8776 38.2587 25.0463 38.1971 25.2129 38.1348ZM25.2344 27.416C25.8218 27.4162 26.2988 27.8972 26.2988 28.4893V33.502C26.2894 33.9515 26.2363 34.7491 26.0312 35.7031C25.4057 35.8202 24.753 35.8296 24.0752 35.7256C23.5975 35.6523 23.1479 35.5321 22.7295 35.3711C23.0305 34.2212 23.0087 33.2891 23.0078 33.2627L23.0059 33.1885V30.7354H17.998C17.0885 30.7353 16.3516 29.9919 16.3516 29.0752C16.3518 28.1586 17.0886 27.4161 17.998 27.416H25.2344Z",
    fill: "url(#paint1_linear_117_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0032 31.0467H23.0088V30.3185H18.0032C17.2754 30.3185 16.6188 29.5534 16.3486 29.127C16.3486 29.3586 16.3486 29.3917 16.3817 29.5903C16.4986 30.2916 17.0892 31.0467 18.0032 31.0467Z",
    fill: "#F08C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0986 28.9186C10.0986 23.5564 14.1945 19.7202 19.7046 19.7202C21.9142 19.7202 23.8588 20.3028 25.3987 21.3929C26.3284 22.0507 26.4033 23.411 25.5686 24.1862C24.9357 24.7739 23.9793 24.8211 23.2829 24.3098C22.3074 23.5933 21.1798 23.2262 19.9075 23.2262C16.5956 23.2262 14.2452 25.5643 14.2452 28.9173C14.2452 32.2702 16.5969 34.6084 19.9075 34.6084C21.1798 34.6084 22.3087 34.2412 23.2829 33.5145C23.9793 32.9969 24.9407 33.0416 25.5775 33.6318C26.4109 34.4044 26.3373 35.7583 25.4139 36.4213C23.8714 37.5279 21.9155 38.1143 19.6805 38.1143C14.1945 38.1156 10.0986 34.2795 10.0986 28.9186Z",
    fill: "#D500F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0986 28.9186C10.0986 23.5564 14.1945 19.7202 19.7046 19.7202C21.9142 19.7202 23.8588 20.3028 25.3987 21.3929C26.3284 22.0507 26.4033 23.411 25.5686 24.1862C24.9357 24.7739 23.9793 24.8211 23.2829 24.3098C22.3074 23.5933 21.1798 23.2262 19.9075 23.2262C16.5956 23.2262 14.2452 25.5643 14.2452 28.9173C14.2452 32.2702 16.5969 34.6084 19.9075 34.6084C21.1798 34.6084 22.3087 34.2412 23.2829 33.5145C23.9793 32.9969 24.9407 33.0416 25.5775 33.6318C26.4109 34.4044 26.3373 35.7583 25.4139 36.4213C23.8714 37.5279 21.9155 38.1143 19.6805 38.1143C14.1945 38.1156 10.0986 34.2795 10.0986 28.9186Z",
    fill: "url(#paint2_linear_117_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6533 19.7202C21.8627 19.7203 23.8069 20.3032 25.3467 21.3931C26.2765 22.0509 26.3512 23.4109 25.5166 24.186C25.4156 24.2798 25.3055 24.3582 25.1904 24.4243C23.2877 22.1114 20.5948 20.4727 17.5244 19.9224C18.2045 19.7906 18.9162 19.7202 19.6533 19.7202Z",
    fill: "url(#paint3_linear_117_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.657 19.7356C19.8729 19.734 20.0869 19.739 20.2977 19.7485C21.1895 20.7691 21.7475 22.0878 21.8019 23.5384C21.2045 23.3359 20.5653 23.2349 19.8856 23.2399C16.574 23.2641 14.2407 25.6196 14.2651 28.9724C14.267 29.2323 14.2842 29.4859 14.3136 29.7328C12.6172 29.3427 11.1882 28.2484 10.3554 26.7703C11.2934 22.6003 14.9473 19.7701 19.657 19.7356Z",
    fill: "url(#paint4_linear_117_216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7554 37.8902C21.9055 37.8581 22.0536 37.8229 22.2 37.7857C22.9184 36.5909 23.2422 35.1539 23.0313 33.6772C22.4131 34.073 21.7133 34.3429 20.9334 34.4827C17.6734 35.0669 14.9467 33.1799 14.3552 29.8795C14.2922 29.5276 14.259 29.1822 14.2513 28.8455C12.6214 29.5794 11.4012 30.9733 10.8637 32.6353C12.5167 36.6434 16.6662 38.8091 21.3519 37.9694L21.7554 37.8902Z",
    fill: "url(#paint5_linear_117_216)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03174 0C7.50728 0.000110011 9.45151 1.76541 9.51025 3.96094C9.51888 4.1351 9.5349 4.32818 9.56006 4.53613C6.89253 4.79742 4.43699 5.78139 2.39209 7.29004C1.20747 6.5649 0.547402 5.45683 0.547363 4.05957C0.547363 1.81839 2.55609 0 5.03174 0Z",
    fill: "url(#paint6_linear_117_216)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.9858 10.8047C15.5626 10.8745 16.1019 10.9117 16.5363 10.9392C19.2049 11.1088 21.2377 12.4987 21.3694 14.7571C21.4819 16.6887 20.2316 18.3827 17.8722 18.9992C17.1671 19.1439 16.4903 19.269 15.8523 19.4046C16.0185 18.2489 16.0725 17.0592 16.0019 15.8478C15.9003 14.1064 15.5483 12.4109 14.9858 10.8047Z",
    fill: "url(#paint7_linear_117_216)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.58105 10.137C10.5879 10.0119 11.7604 10.018 13.1602 10.2103C13.7611 10.4449 14.4169 10.6104 15.041 10.7308C18.2541 12.1427 20.6835 15.9761 18.4043 18.8275C18.1569 18.912 17.8951 18.9833 17.6191 19.0384C16.1543 19.3316 14.8473 19.5876 13.7275 20.0521C12.9622 19.5736 12.2495 18.7971 11.5801 17.8753C12.0263 17.1118 12.293 16.2542 12.293 15.3109C12.293 13.1549 11.2538 11.4021 9.58105 10.137Z",
    fill: "url(#paint8_linear_117_216)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.03809 9.76684C10.3585 9.72243 11.7547 9.8387 13.0908 10.1877C13.4558 10.3338 13.842 10.4539 14.2305 10.553C17.2625 11.7511 19.6275 16.3118 17.2021 19.1194C15.7951 19.4019 14.5424 19.6707 13.4717 20.1575C12.7278 19.742 12.0585 18.9763 11.4521 18.0608C11.9666 17.2516 12.2803 16.3316 12.2803 15.3108C12.2802 12.9357 11.0181 11.0503 9.03809 9.76684Z",
    fill: "url(#paint9_linear_117_216)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28711 21.6758C7.56744 21.5869 5.76048 21.6717 4.26824 21.9658C1.35374 22.5401 -0.694837 25.3765 1.29358 28.0953C1.33074 28.1099 1.36696 28.1276 1.40487 28.1417C2.60076 28.5852 3.676 28.9774 4.57588 29.505C5.37545 29.2575 6.1703 28.6805 6.91919 27.9571C6.63263 27.2192 6.51729 26.4236 6.6498 25.5896C6.92234 23.875 7.89094 22.5661 9.28711 21.6758Z",
    fill: "url(#paint10_linear_117_216)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03174 30.0342C7.50729 30.0341 9.59311 28.1682 9.65186 25.9727C9.65898 25.8289 9.67023 25.6737 9.68506 25.5088C6.96927 25.2664 4.46887 24.2763 2.39209 22.7441C1.20747 23.4693 0.547402 24.5773 0.547363 25.9746C0.547363 28.2158 2.55609 30.0342 5.03174 30.0342Z",
    fill: "url(#paint11_linear_117_216)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_216",
    x1: 2.69733,
    y1: 4.64196,
    x2: 5.68087,
    y2: 29.1264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_216",
    x1: 17.3812,
    y1: 29.8412,
    x2: 18.0208,
    y2: 40.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579043,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745243,
    stopColor: "#FD7E02",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA303",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_216",
    x1: 21.2225,
    y1: 37.2363,
    x2: 18.6702,
    y2: 20.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_117_216",
    x1: 40.0091,
    y1: 33.2503,
    x2: 18.6888,
    y2: 14.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_117_216",
    x1: 8.10659,
    y1: 48.5396,
    x2: 9.36655,
    y2: 19.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_117_216",
    x1: 21.6049,
    y1: 36.4519,
    x2: -6.34616,
    y2: 36.4619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#FD7E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_117_216",
    x1: 0.547363,
    y1: 5.84004,
    x2: 9.54879,
    y2: 4.56871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2960F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#3F8EEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_117_216",
    x1: 10.2954,
    y1: 10.4583,
    x2: 18.0057,
    y2: 16.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_117_216",
    x1: 11.8879,
    y1: 11.7746,
    x2: 18.0757,
    y2: 18.5515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_117_216",
    x1: 11.2142,
    y1: 11.5486,
    x2: 14.4369,
    y2: 20.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_117_216",
    x1: 0.308916,
    y1: 23.6041,
    x2: 5.97256,
    y2: 28.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#F2A73B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_117_216",
    x1: 10.3007,
    y1: 26.3856,
    x2: 0.55008,
    y2: 25.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#F2A73B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0406,
    height: 18.6897,
    fill: "white",
    transform: "translate(10.0986 19.7202)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossierBotIcon);
export default __webpack_public_path__ + "static/media/dossier-bot-icon.cd6332cf1131e46f4557a50cfae7ed4b.svg";
export { ForwardRef as ReactComponent };